import { Button, Dialog } from '@wonderschool/common-base-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface QuickSaveConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (dontAskAgain: boolean) => void;
}

const QuickSaveConfirmationModal: React.FC<QuickSaveConfirmationModalProps> = ({ isOpen, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  const [dontAskAgain, setDontAskAgain] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm(dontAskAgain);
  };

  return (
    <Dialog
      isOpen={isOpen}
      hasCloseButton
      onClose={onCancel}
      data-testid="quick-save-confirmation-modal"
      extraClasses="md:w-1/2 md:max-w-1/2"
    >
      <Dialog.Panel>
        <Dialog.Title>{t('enrollments.quickSaveConfirmationTitle')}</Dialog.Title>
        <Dialog.Description>
          <div className="space-y-4">
            <div className="space-y-3 text-gray-900">
              <p>{t('enrollments.quickSaveConfirmationMessage')}</p>
              <p className="text-sm">{t('enrollments.quickSaveConfirmationSubMessage')}</p>
            </div>

            <div>
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={dontAskAgain}
                  onChange={(e) => setDontAskAgain(e.target.checked)}
                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  data-testid="quick-save-dont-ask-again"
                />
                <span className="text-sm text-gray-900">{t('enrollments.dontAskMeThisAgain')}</span>
              </label>
            </div>
          </div>
        </Dialog.Description>
      </Dialog.Panel>
      <Dialog.Actions>
        <Button
          label={t('enrollments.exitConfirmationModalGoBack')}
          extraClasses="w-full"
          onClick={onCancel}
          data-testid="quick-save-modal-go-back"
        />
        <Button
          label={t('common.continue')}
          extraClasses="w-full"
          onClick={handleConfirm}
          primary
          data-testid="quick-save-modal-continue"
        />
      </Dialog.Actions>
    </Dialog>
  );
};

export default QuickSaveConfirmationModal;
